document.addEventListener('DOMContentLoaded', function () {
    if (window.matchMedia('(min-width: 990px)').matches) {
      let videoBlocks = document.querySelectorAll('.video-block');
      let playButton = document.querySelector('.video-play-button');
      let videoPlayBtn = document.querySelector('.play-icon');
      let videoDescription = document.querySelector('.video-description');
      let videoMain = document.querySelector('.video-main');
  
      videoBlocks.forEach(function (videoBlock, index) {
        videoBlock.addEventListener('click', function () {
          videoBlocks.forEach(function (block) {
            block.classList.remove('active');
          });
          this.classList.add('active');
          videoPlayBtn.classList.add('hidden');
              // Scroll to video-main div with animation
            if (document.querySelector('.not-scroll')) {
                videoBlocks.forEach(function(videoBlock) {
                    // Add a click event listener to each video-block element
                    videoBlock.addEventListener('click', function() {
                        let videoMain = document.querySelector('.not-scroll .video-list-content');
                        if (videoMain) {
                            let scrollToTop = videoMain.offsetTop + 800;
                            window.scrollTo({
                                top: scrollToTop,
                                behavior: 'smooth',
                            });
                        }
                    });
                });
            } else {
                let scrollToTop = videoMain.offsetTop;
                window.scrollTo({
                    top: scrollToTop,
                    behavior: 'smooth',
                });
            }
           
          let video = this.querySelector('video');
          let youtubeUrl = this.querySelector('.video-container.yt_video iframe');
  
          if (youtubeUrl) {
            // If YouTube video iframe exists, append it to video-main div
            let iframeClone = youtubeUrl.cloneNode(true);
            videoMain.innerHTML = '';
            videoMain.appendChild(iframeClone);
            
            // Get the video-list-description of this block
            let description = this.querySelector('.video-list-description p');
            videoDescription.innerHTML = ''; // Clear previous content
            if (description) {
              videoDescription.appendChild(description.cloneNode(true)); // Append the description
            }
            // Hide play button and icon for YouTube videos
            playButton.style.display = 'none';
            videoPlayBtn.style.display = 'none';

          } 
          else if (video) {
            // If video file is uploaded, append it to video-main div
            let clonedVideo = video.cloneNode(true);
            videoMain.innerHTML = '';
            videoMain.appendChild(clonedVideo);
  
            // Get the video-list-description of this block
            let description = this.querySelector('.video-list-description p');
            videoDescription.innerHTML = ''; // Clear previous content
            if (description) {
              videoDescription.appendChild(description.cloneNode(true)); // Append the description
            }
            
            // Show play button and icon for uploaded videos
            playButton.style.display = 'block';
            videoPlayBtn.style.display = 'block';
          }
        });
  
        if (index === 0) {
          videoBlock.click();
        }
      });
  
      playButton?.addEventListener('click', function () {
        let video = videoMain.querySelector('video');
        let youtubeUrl = videoMain.querySelector('.video-container.yt_video iframe');
        let videoPlayBtn = document.querySelector('.play-icon');
        videoPlayBtn.classList.toggle('hidden');
        if (video) {
          if (video.paused) {
            video.play(); // If video is paused, play it
          } else {
            video.pause(); // If video is playing, pause it
          }
        } else if (youtubeUrl) {
          // If YouTube video iframe exists, toggle play/pause
          let player = youtubeUrl.contentWindow;
          if (player.postMessage) {
            player.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
          }
        }
      });
    }
});

// Define stopYouTubeVideo function in the global scope
window.stopYouTubeVideo = function (iframeId) {
  let youtubeUrl = document.getElementById(`${iframeId}`);
  if (youtubeUrl) {
      let player = youtubeUrl.contentWindow;
      if (player.postMessage) {
          player.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      }
  }
};  

function showDialogWithVideo(blockId) {
    if (window.matchMedia('(max-width: 989px)').matches) {
      document.getElementById(`${ blockId }`).showModal();
      document.querySelector('body').classList.add('overflow-hidden');
    }
  }

function closeDialog(blockId) {
  if (window.matchMedia('(max-width: 989px)').matches) {
    document.getElementById(`${ blockId }`).close();
    document.querySelector('body').classList.remove('overflow-hidden');
    stopYouTubeVideo('youtube-' + blockId);
  }
}




